import { httpRequest } from "@src/utils/HttpRequest";
import { IPage } from "@src/types/FmsTypes";

class RosterService {

    async baseInfoPage(searchVo: any) {
        const apiUrl = "/auth/user/employeePage";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }

    async contractInfoPage(searchVo: any) {
        const apiUrl = "/user/contracts/page";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }

    async getDetail(searchVo: any) {
        const apiUrl = "/auth/user/employeeFind";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }

    async export(searchVo: any) {
        const apiUrl = "/auth/user/export";
        return await httpRequest.postFile(apiUrl, searchVo);
    }

    async downloadTpl(searchVo: any) {
        const apiUrl = "/auth/user/downloadTpl";
        return await httpRequest.getFile(apiUrl, searchVo);
    }

    //紧急联系人新增
    async emergencyInsert(searchVo: any) {
        const apiUrl = "/user/emergency/insert";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }

    //职业发展技能证书新增
    async certificatesInsert(searchVo: any) {
        const apiUrl = "/user/certificates/insert";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }

    //新增合同信息
    async contractInsert(searchVo: any) {
        const apiUrl = "/user/contracts/insert";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }

    //员工工作经历新增
    async workInsert(searchVo: any) {
        const apiUrl = "/user/work/insert";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }

    //员工其他信息文件新增
    async fileInsert(searchVo: any) {
        const apiUrl = "/user/file/insert";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }

    //员工薪资记录查询
    async salaryPage(searchVo: any) {
        const apiUrl = "/user/salary/page";
        return await httpRequest.post<IPage<any>>(apiUrl, searchVo);
    }

    //员工薪资信息保存
    async salaryInsert(searchVo: any) {
        const apiUrl = "/user/salary/insert";
        return await httpRequest.post<any>(apiUrl, searchVo);
    }

    //取消预警提醒
    async cancelReminder(contractId: string) {
        const apiUrl = `/user/contracts/cancelReminder/${contractId}`;
        return await httpRequest.get<any>(apiUrl);
    }

}
export const rosterService = new RosterService();
